import styles from "./index.module.css";
import { useContext } from "react";
import UserContext from "../../../store/UserStore/context";
import getLevelInfo from "../helpers";
import { levels } from "../enums";

export default function TeachersBlock() {
  const userStore = useContext(UserContext);
  const score = userStore.store.user.testResult;

  const { key } = getLevelInfo(score);
  const data = levels[key];
  if (!data) return null;
  const { teachers } = data;

  return (
    <div className={styles.teachersBlock}>
      {teachers.map((item, index) => (
        <div
          className={styles.teacher + (index === 1 ? " " + styles.reverse : "")}
        >
          <img src={item.img} alt={item.name} />
          <div>
            <h2>{item.name}</h2>
            <div className={styles.month}>{item.month}</div>
            <div className={styles.desc}>{item.description}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
